<template>
  <div class="pagination" v-if="pagination.total! > 1">
    <button
      class="button back"
      @click="emits('paginate', pagination.current_page ? pagination.current_page - 1 : 1)"
      :class="{ hidden: !pagination?.prev_page_url }"
    >
      Volgende
    </button>
    <span>{{ pagination?.current_page }} / {{ pagination?.last_page }}</span>
    <button
      class="button next"
      @click="emits('paginate', pagination.current_page ? pagination.current_page + 1 : 1)"
      :class="{ hidden: !pagination?.next_page_url }"
    >
      Vorige
    </button>
  </div>
</template>

<script setup lang="ts">
import type { Results } from '@/types/search';

defineProps<{
  pagination: Partial<Results>;
}>();

const emits = defineEmits<{ (e: 'paginate', page: number): void }>();
</script>

<style scoped>
.hidden {
  visibility: hidden;
}

.pagination {
  margin-top: 3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

button {
  margin: 0 10px;
}
</style>
